import { darken, styled } from '@mui/material';
import { Editor as EditorComponent } from '@tinymce/tinymce-react';
import { useRef } from 'react';
import { Editor } from 'tinymce';
import LoadingScreen from '../LoadingScreen';
import { tinymceInitConfig, tinymceScriptSrc } from './config';

const EditorLoading = styled(LoadingScreen)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const Container = styled('div')`
  position: relative;

  & > textarea {
    display: none;
  }

  .tox-tinymce {
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    border-color: ${({ theme }) => darken(theme.palette.background.default, 0.03)};
  }

  .tox {
    .tox-statusbar {
      border-top: none;

      .tox-statusbar__text-container {
        display: none;
      }
    }
  }
`;

export interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  border?: boolean;
  minHeight?: number;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  disabled,
  border = true,
  minHeight = tinymceInitConfig?.min_height
}) => {
  const editorRef = useRef<Editor>();

  return (
    <Container sx={{ minHeight, '.tox-tinymce': { border: !border ? 'none' : undefined } }}>
      <EditorLoading />
      <EditorComponent
        tinymceScriptSrc={tinymceScriptSrc}
        onInit={(_, editor) => (editorRef.current = editor)}
        init={{ ...tinymceInitConfig, min_height: minHeight }}
        onEditorChange={(content) => onChange(content)}
        value={value}
        disabled={disabled}
      />
    </Container>
  );
};

export default RichTextEditor;
